import React from 'react';

const ExpandIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M21 5v16H5v-8h2v6h12V7h-6.116V5H21zM8 3v2H6.415l6.292 6.293-1.414 1.414L5 6.415V8H3V3h5z" />
  </svg>
);

export default ExpandIcon;
